export default __webpack_public_path__ + "static/media/new_enviro_ logo.8d86df25.jpg";